// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';

import Modal from './Modal';

import api from '../../api';

import '../../styles/start.css';

export default class DeactivateAccount extends Modal {

    state = {
        reason: ""
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">

            <h1>Permanently Delete Team</h1>

            <p>
                We're sorry Stax·ai didn't work out for you. If you didn't get to fully explore it or couldn't find an application for your business, please let your account manager know. We have a team to help you get the most out of Stax·ai and be successful!
            </p>

            {/* <div className="point-of-contact" style={{ marginTop: -40 }}>
                <img
                    src="https://static.stax.ai/images/other/mckenzie.png"
                    alt="McKenzie Glandorf"
                />
                <h1>McKenzie Glandorf</h1>
                <h3>VP of Customer Success</h3>
                <div 
                    className="point-of-contact-email"
                    onClick={() => window.open('mailto:mckenzie@stax.ai', '_blank')}
                >mckenzie@stax.ai</div>
            </div> */}

            <br /><br /><br />

            <h2 style={{ marginBottom: -20 }}>Reason for leaving</h2>
            <div className="form-line form-line-long">
                <textarea
                    placeholder="Please let us know why you're leaving - we really appreciate your feedback! We really try to learn as much as we can to improve Stax·ai..."
                    onChange={(e) => this.setState({
                        reason: e.target.value
                    })}
                    value={this.state.reason}
                >
                </textarea>
            </div>
            
            <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/goodbye.png')",
                    marginTop: 20
                }}
                onClick={async () => {
                    if (!this.state.reason || this.state.reason === "")
                        return toast.error("Reason for leaving cannot be empty. Please give us some feedback on why you're leaving.");

                    await this.props.loading(1005);
                    const res = await api.post('/team/remove', { reason: this.state.reason });
                    if (!res || !res.success)
                        return this.props.loaded();

                    toast.success("Deleted team account. We're sorry to see you go!");
                    this.props.loaded();
                    setTimeout(() => window.location.href = "https://stax.ai", 500);
                }}
            >Permanently Delete Team</div>
            
        </div>);
    }

};